import ItemCustomerDTO from "../../DTO/ItemCustomerDTO"
import mainservice from "../../../services/MainService"
import { OptionArray, OptionArrayHasValue, OptionArrayValue } from "../../../services/OptionArrayParser"
import { useEffect, useState } from "react"
import { Status } from "../day/dayView"
import { countryDisplay } from "../../../services/country"
import { LexwareButton } from "../Lexware/LexwareButton"
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DeleteIcon from '@mui/icons-material/Delete';
import ClearIcon from '@mui/icons-material/Clear';
import InlineMenu from "../../elements/InlineMenu"
import { Button } from "@mui/material"
import { Star, StarBorder } from "@mui/icons-material"

export default function Customer(props: {
  item: ItemCustomerDTO,
  onClick?: (id: number, item: ItemCustomerDTO) => void,
  className?: string,
  onTrash?: (id: number) => void,
  onRemove?: () => void,
  options?: OptionArray,
}) {
  const item: ItemCustomerDTO = props.item
  const [status, setStatus] = useState(Status.standard)
  const customerPersonLexwareId = OptionArrayValue(props.options, 'customerPersonLexware')
  return <div
    className={`STCustomer PTListItem ${props.className || ''}`}
  >
    <div className={`flex align-items-top`}>
      <Button
        onClick={async () => {
          setStatus(Status.loading)
          await item.toggleTagForUser()
          setStatus(Status.standard)
        }}
        sx={{
          paddingTop: 2,
        }}
      >
        {
          item.isTaggedByUser() ? <Star /> : <StarBorder />
        }
      </Button>
      <button
        className={`w3-button flex-grow textLeft`}
        onClick={() => {
          if (props.onClick) {
            props.onClick(item.id, item)
            return
          }
          mainservice.navTo([['view', 'spCustomerEdit'], ['id', item.id]])
        }}
      >
        
        <DisplayCustomerName
          item={item}
          options={props.options}
        />
      </button>
      <button
        title={`Standort von ...`}
        className={`w3-button textLeft width300`}
        onClick={() => {
          if (props.onClick && item.parentId > -1) {
            props.onClick(item.parentId, item)
            return
          }
          mainservice.navTo([['view', 'spCustomerEdit'], ['id', item.parentId]])
        }}
      >
        {item.parentName}<br />
        {item.parentTown}
      </button>
      
      {
        customerPersonLexwareId === undefined && !OptionArrayHasValue(props.options, 'noLexware', 'yes') && <LexwareButton item={item} kind='customer' />
      }
      <InlineMenu
        title={
          <MoreVertIcon />
        }
        options={[
          {
            show: true,
            onClick: () => {
              navigator.clipboard.writeText(item.getPrintAddress(OptionArrayValue(props.options, 'customerPrefixAddress'))).then(function() {
                console.log('Text copied to clipboard');
              });
            },
            title: 'In Zwischenablage kopieren',
            icon: <ContentCopyIcon />
          },
          {
            show: !!props.onTrash,
            onClick: () => {
              if (props.onTrash) {
                props.onTrash(item.id)
              }
            },
            title: 'Löschen',
            icon: <DeleteIcon />
          },
          {
            show: !!props.onRemove,
            onClick: props.onRemove,
            title: 'Entfernen',
            icon: <ClearIcon />
          }
        ]}
        />
    </div>
    {
      customerPersonLexwareId &&
      <div className='w3-padding'>
        <LexwareButton
          item={item}
          kind='customer'
          displayBillList={true}
          personId={customerPersonLexwareId}
        />
      </div>
    }
</div>
}

export function DisplayCustomerName(props: {
  item: ItemCustomerDTO,
  options?: [string, string][]
  onClick?: () => void,
  lazy?: boolean,
}) {
  const [item, setItem] = useState(props.item) // props.item
  const options = props.options
  const onClick = props.onClick || (() => {})
  const [status, setStatus] = useState(props.lazy ? Status.loading : Status.standard)
  useEffect(() => {
    if (props.lazy) {
      const newItem = new ItemCustomerDTO(item)
      newItem.getFromServer().then(() => {
        setItem(newItem)
        setStatus(Status.standard)
      })
    }
  })
  if (!item || !item.getPropV1) {
    // TODO - Hier sollte man einen Counter einbauen - wenn das zu oft passiert, sollte es nicht weiter versucht werden!
    console.log('Customer item is not defined', item)
    setItem(new ItemCustomerDTO(item))
    return null
  }
  if (status === Status.standard && OptionArrayHasValue(options, 'customerShowAddress', 'yes')) {
    return <>
      <div onClick={onClick}>{item.name}</div>
      <div onClick={onClick} className='lightFont' dangerouslySetInnerHTML={{__html: 
        [
          item.getPropV1('data', 'street'),
          [item.getPropV1('data', 'postalcode'), item.getPropV1('data', 'town')].filter(i => i).join(' '),
          countryDisplay(item.getPropV1('data', 'country'))
        ].filter(i => i).join('<br />')
      }}>

      </div>
    </>
  }
  if (status === Status.standard && OptionArrayHasValue(options, 'customerShowCityAndAddress', 'yes')) {
    return <>
      <div onClick={onClick}>{item.name}</div>
      <div onClick={onClick} className='lightFont'>
        {item.getCityAndAddress()}
      </div>
    </>
  }
  return <>{item.name}</>
}
